import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
import { VariantPackCostChangeDataFieldsFragmentDoc } from './variant-pack-cost-change-data-fragments.generated';
const defaultOptions = {} as const;

export const PricingVariantPackCostChangeDataDocument = gql`
  query PricingVariantPackCostChangeData($variantPackUUIDs: [uuid!]) {
    getVariantPackCostChangeDataForBusinessOrganization(
      variant_pack_ids: $variantPackUUIDs
    ) {
      ...VariantPackCostChangeDataFields
    }
  }
  ${VariantPackCostChangeDataFieldsFragmentDoc}
`;
export function usePricingVariantPackCostChangeDataQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.PricingVariantPackCostChangeDataQuery,
    Types.PricingVariantPackCostChangeDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PricingVariantPackCostChangeDataQuery,
    Types.PricingVariantPackCostChangeDataQueryVariables
  >(PricingVariantPackCostChangeDataDocument, options);
}
export function usePricingVariantPackCostChangeDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PricingVariantPackCostChangeDataQuery,
    Types.PricingVariantPackCostChangeDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PricingVariantPackCostChangeDataQuery,
    Types.PricingVariantPackCostChangeDataQueryVariables
  >(PricingVariantPackCostChangeDataDocument, options);
}
export type PricingVariantPackCostChangeDataQueryHookResult = ReturnType<
  typeof usePricingVariantPackCostChangeDataQuery
>;
export type PricingVariantPackCostChangeDataLazyQueryHookResult = ReturnType<
  typeof usePricingVariantPackCostChangeDataLazyQuery
>;
export type PricingVariantPackCostChangeDataQueryResult = Apollo.QueryResult<
  Types.PricingVariantPackCostChangeDataQuery,
  Types.PricingVariantPackCostChangeDataQueryVariables
>;

/**
 * Wrapped version of useGeneratedPricingVariantPackCostChangeDataQuery using Pepper's useWrappedQuery
 */
export function useGeneratedPricingVariantPackCostChangeDataQuery(
  options?: Apollo.QueryHookOptions<
    Types.PricingVariantPackCostChangeDataQuery,
    Types.PricingVariantPackCostChangeDataQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.PricingVariantPackCostChangeDataQuery,
    Types.PricingVariantPackCostChangeDataQueryVariables
  >(PricingVariantPackCostChangeDataDocument, options);
}

/**
 * Wrapped version of useGeneratedPricingVariantPackCostChangeDataLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedPricingVariantPackCostChangeDataLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.PricingVariantPackCostChangeDataQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.PricingVariantPackCostChangeDataQuery,
    Types.PricingVariantPackCostChangeDataQueryVariables
  >(PricingVariantPackCostChangeDataDocument, lazyOptions);
}
